import { AUTH_HEADER } from '@/core/constants/http-headers'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { UnauthorizedError } from '@/core/types/errors/http-error'
import { RefundResponse } from '../types/api-responses/refund-details-response'
import { RefundRequestModel } from '../types/models/refund-request.model'

export function createRefundUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function (input: RefundRequestModel) {
    const { token, accountType } = await tokenService.getToken()
    if (!token) {
      throw new UnauthorizedError()
    }
    const req = inputToJson(input)
    await httpClient.version('v1').addHeaders(AUTH_HEADER(token)).post<{
      data: RefundResponse
    }>(`/website/${accountType}/refundPriceTripUpdate`, req)
  }
}

function inputToJson({ refundMethod, tripId }: RefundRequestModel) {
  return { trip_id: tripId, refund_to: refundMethod }
}
